module.exports = __webpack_public_path__ + "img/01-thumbnail.eda45981.jpg";